const routes = [
    {
        path: '/school/home',
        component: () => import('../views/School/home.vue'),
        redirect: '/school/account/account_center', // 改为账号管理

        children: [
            {
                path: '/school/account/account_center',
                component: () => import('../views/School/account/account_center.vue'),
                meta: {
                    title: '师生管理'
                }
            },
            // {
            //     path: '/school/account/teacher_edit',
            //     component: () => import('../views/School/account/teacher_edit.vue'),
            //     meta: {
            //         title: '账号编辑'
            //     }
            // },
            {
                path: '/school/classes/classes_manage',
                component: () => import('../views/School/classes/classes_manage.vue'),
                meta: {
                    title: '班级管理'
                }
            },
            {
                path: '/school/classroom/classroom_list',
                component: () => import('../views/School/classroom/classroom_list.vue'),
                meta: {
                    title: '教室列表'
                }
            },

            {
                path: '/school/classroom/classroom_edit',
                component: () => import('../views/School/classroom/classroom_edit.vue'),
                meta: {
                    title: '教室编辑'
                }
            },
            {
                path: '/school/materia/materia_manage',
                component: () => import('../views/School/materia/materia_manage.vue'),
                meta: {
                    title: '课程资源管理'
                }
            },
            // {
            //     path: '/school/materia/materia_detail',
            //     component: () => import('../views/School/materia/materia_detail.vue'),
            //     meta: {
            //         title: '教材详情'
            //     }
            // },
            {
                path: '/school/materia/materia_authorize',
                component: () => import('../views/School/materia/materia_authorize.vue'),
                meta: {
                    title: '教材授权'
                }
            },
            {
                path: '/school/aiconfig/ai_config',
                component: () => import('../views/School/aiconfig/ai_config.vue'),
                meta: {
                    title: 'AI能力额度管理'
                }
            },
            {
                path: '/school/aiconfig/ai_frequency_edit',
                component: () => import('../views/School/aiconfig/school_AI_frequency.vue'),
                meta: {
                    title: '修改频次',
                    active: true,
                    jumpPath: '/school/aiconfig/ai_config'
                }
            },

            {
                path: '/school/schedule/schedule_manage',
                component: () => import('../views/School/schedule/schedule_manage.vue'),
                name: 'schoolScheduleManage',
                meta: {
                    title: '排课管理'
                }
            },
            {
                path: '/school/statistics/customerData',
                name: 'customerData',
                component: () => import('../views/School/statistics/CustomerData/index.vue'),
                meta: {
                    title: '教学数据'
                }
            },
            {
                path: '/school/statistics/AIMonitor',
                name: 'AIMonitor',
                component: () => import('../views/School/statistics/AIMonitor/index.vue'),
                meta: {
                    title: 'AI能力监测'
                }
            },
            {
                path: '/school/classes/view_student',
                component: () => import('../views/School/classes/view_student.vue'),
                name: 'viewStudent',
                meta: {
                    title: '查看学生',
                    active: true,
                    jumpPath: '/school/classes/classes_manage'
                }
            },
            // 班级管理内关联课程页面
            {
                path: '/school/classes/class_authorize',
                component: () => import('../views/School/classes/class_authorize_book.vue'),
                name: 'viewClassAuthorize',
                meta: {
                    title: '关联课程',
                    active: true,
                    jumpPath: '/school/classes/classes_manage'
                }
            },
            // 课程管理内关联班级页面
            {
                path: '/school/materia/meteria_class',
                component: () => import('../views/School/materia/meteria_class.vue'),
                name: 'viewAuthorizeClass',
                meta: {
                    title: '关联班级',
                    active: true,
                    jumpPath: '/school/materia/materia_manage'
                }
            }
        ]
    }
];

export default {
    routes
};
